export default __webpack_public_path__ + "static/media/dsaf-assignment02.docx.986af707.pdf";